<template>
    <d2-container>
        <h2>车辆加油记录</h2>
        <el-form ref="elForm" :model="formData" size="medium" label-width="140px">
            <el-row type="flex" justify="start" align="top">
                <el-form-item label="注册区县" prop="cityReq">
                    <town-com v-on:on-selectLast="(e) => listQuery.addressStreetId = e"></town-com>
                </el-form-item>
                <el-form-item label="企业名称">
                    <el-input v-model="listQuery.entName" placeholder="请输入企业名称" clearable
                        :style="{ width: '445px' }"></el-input>
                </el-form-item>
            </el-row>
            <el-row>
                <el-form-item label="撬装设备编码" prop="dd">
                    <el-input v-model="listQuery.oilEdequipmentCode" placeholder="撬装设备编码" clearable
                        :style="{ width: '763px' }"></el-input>
                </el-form-item>
                <el-form-item label="识别状态" prop="dd">
                    <el-col :span="3">
                        <el-select v-model="listQuery.alarmStatus" placeholder="请选择" :style="{ width: '219px' }">
                            <el-option v-for="item in alarmSelects" :key="item.value" :label="item.label"
                                :value="item.value">
                            </el-option>
                        </el-select>
                    </el-col>
                    <el-col :span="45" style="padding-left:22px;">
                        <el-form-item label="车牌号码" prop="dd">
                            <el-input v-model="listQuery.truckNo" placeholder="车牌号码" clearable
                                :style="{ width: '448px' }"></el-input>
                        </el-form-item>
                    </el-col>
                </el-form-item>
            </el-row>
            <el-form-item size="large">
                <el-button size="small" class="filter-item" type="primary" icon="search"
                    @click="handleFilter">查询</el-button>
                <el-button @click="resetForm">重置</el-button>
            </el-form-item>
        </el-form>


        <!--表格-->
        <!--<el-button size="small" class="filter-item"  style="margin-left: 10px;" @click="handleCreate" type="primary" icon="edit">新增材料</el-button>-->
        <el-button size="small" class="filter-item" style="margin-left: 10px;" @click="exportData('c', '车辆加注记录.csv')"
            type="primary" icon="edit">导出全部数据</el-button>

        <el-table :key='tableKey' :data="list" v-loading.body="listLoading" size="small" stripe highlight-current-row
            style="width: 100%">
            <el-table-column prop="oilid" type="selection" width="55" label="序号">
            </el-table-column>
            <el-table-column prop="truckNo" label="车牌号码" width="120">
            </el-table-column>
            <el-table-column prop="driverName" label="司机姓名" width="120">
            </el-table-column>
            <el-table-column prop="oilEdequipmentCode" label="撬装设备编码" width="180">
            </el-table-column>
            <el-table-column prop="entName" label="用油企业" width="150">
            </el-table-column>
            <el-table-column prop="addressStreetName" label="所在街镇" width="180">
            </el-table-column>
            <!-- <el-table-column
                    label="油品类型"
            >
                <template slot-scope="scope">{{ scope.row.oilType==1?'柴油':'汽油' }}</template>
            </el-table-column> -->
            <el-table-column prop="injectionVolume" label="加油量（L）" width="120">
            </el-table-column>
            <!--            <el-table-column-->
            <!--                    prop="injectionWeight"-->
            <!--                    label="重量"-->
            <!--            >-->
            <!--            </el-table-column>-->
            <!--            <el-table-column-->
            <!--                    label="识别状态"-->
            <!--            >-->
            <!--                <template slot-scope="scope">{{ alarmStatus(scope.row.alarmStatus) }}</template>-->
            <!--            </el-table-column>-->
            <!--          <el-table-column-->
            <!--                  label="是否监管"-->
            <!--          >-->
            <!--              <template slot-scope="scope">{{ scope.row.isSupervise?'是':'否' }}</template>-->
            <!--          </el-table-column>-->
            <el-table-column prop="injectionTime" label="加油时间" width="180">
            </el-table-column>
            <el-table-column fixed="right" label="操作" width="120">
                <template slot-scope="scope">
                    <el-button size="small" @click="handleClick(scope.row)">查看</el-button>
                    <!--<el-button size="small" type="success" @click="handleUpdate(scope.row)">编辑</el-button>-->
                    <!--<el-button size="small" type="danger" @click="handleDelete(scope.row)">删除</el-button>-->
                </template>
            </el-table-column>
        </el-table>

        <!--分页-->
        <template slot="footer">
            <div v-show="!listLoading" class="pagination-container">
                <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange"
                    :current-page.sync="listQuery.page" :page-sizes="[10, 20, 30, 50]" :page-size="listQuery.limit"
                    layout="total, sizes, prev, pager, next, jumper" :total="total"> </el-pagination>
            </div>
        </template>


        <el-dialog :title="textMap[dialogStatus]" :visible.sync="dialogFormVisible">
            <el-form :model="form" ref="form" label-width="120px">
                <el-form-item label="车牌号码">
                    <el-input v-model="form.truckNo" placeholder="请输入"></el-input>
                </el-form-item>
                <el-form-item label="司机姓名">
                    <el-input v-model="form.driverName" placeholder="请输入"></el-input>
                </el-form-item>
                <el-form-item label="撬装设备编码">
                    <el-input v-model="form.oilEdequipmentCode" placeholder="请输入"></el-input>
                </el-form-item>
                <!-- <el-form-item label="油品类型">
                    <el-input :value="form.oilType == 1 ? '柴油' : '汽油'" placeholder="请输入"></el-input>
                </el-form-item> -->
                <el-form-item label="加油量（升L）">
                    <el-input v-model="form.injectionVolume" placeholder="请输入"></el-input>
                </el-form-item>
                <!-- <el-form-item label="重量">
                    <el-input v-model="form.injectionWeight" placeholder="请输入"></el-input>
                </el-form-item> -->
                <el-form-item label="加油时间">
                    <el-input v-model="form.injectionTime" placeholder="请输入"></el-input>
                </el-form-item>
                <template>
                    <el-form-item label="车辆隶属关系">
                        <el-input :value="form.useType == 0 ? '自用' : '租赁'" placeholder="请输入"></el-input>
                    </el-form-item>
                    <el-form-item label="租赁到期时间" v-if="form.useType != 0">
                        <el-input :value="form.expireTime" placeholder="无租赁时间"></el-input>
                    </el-form-item>
                </template>
            </el-form>
            <div slot="footer" class="dialog-footer">
                <el-button @click="cancel('form')" size="small">取 消</el-button>
                <el-button v-if="dialogStatus == 'create'" size="small" type="primary"
                    @click="create('form')">保存</el-button>
                <el-button v-if="dialogStatus == 'update'" type="primary" size="small"
                    @click="update('form')">更新</el-button>
            </div>
        </el-dialog>

    </d2-container>
</template>


<script>
import {
    page,
    addObj,
    getObj,
    delObj,
    putObj
} from '@/api/admin/sysOilTankTruckoil/index';
import TownCom from "../common/town-com.vue";
import { mapGetters } from 'vuex';
import { exportCsv } from "../../../api/admin/sysOilEdequipment";
export default {
    name: 'sysBaseMaterial',
    components: {
        TownCom
    },
    data() {
        return {
            dialogFormVisible: false,
            formData: {
            },
            list: null,
            total: null,
            listLoading: true,
            listQuery: {
                page: 1,
                limit: 20,
                oilEdequipmentCode: null,
                truckNo: null,
                alarmStatus: null
            },
            alarmSelects: [{ value: "0", label: "正常" }, { value: "2", label: "不一致" }, { value: "-1", label: "未知" }],
            dialogStatus: '',
            textMap: {
                view: '查看',
                update: '编辑',
                create: '创建'
            },
            tableKey: 0,
            form: {
                oilid: null,
                materialName: null,
                explainText: null,
                materialType: null,
                formType: null,
                sort: null,
                useType: null,
                expireTime: null,
            },
            materialTypes: [
                { value: '0', label: '附件上传' },
                { value: '1', label: '表单录入' },
            ]
        }
    },
    created() {
        this.getList();
    },
    computed: {
        ...mapGetters([
            'elements'
        ])
    },
    methods: {
        alarmStatus: function (status) {
            if (status == 0) { return "识别正常" }
            else if (status == 1) { return "未报备" }
            else if (status == 2) { return "不一致" }
            else { return "未知" }
        },
        exportData(type, fileName) {
            exportCsv(type, fileName);
        },
        getList() {
            this.listLoading = true;
            page(this.listQuery).then(response => {
                this.list = response.rows;
                this.total = response.total;
                this.listLoading = false;
            })
        },
        handleFilter() {
            this.getList();
        },
        handleSizeChange(val) {
            this.listQuery.limit = val;
            this.getList();
        },
        handleCurrentChange(val) {
            this.listQuery.page = val;
            this.getList();
        },
        handleCreate() {
            this.resetTemp();
            this.dialogStatus = 'create';
            this.dialogFormVisible = true;
            this.mapShow = false;
        },
        handleClick(row) {
            getObj(row.oilid)
                .then(response => {
                    this.form = response;
                    this.dialogFormVisible = true;
                    this.dialogStatus = 'view';
                });
        }, handleUpdate(row) {
            getObj(row.oilid)
                .then(response => {
                    this.form = response;
                    this.dialogFormVisible = true;
                    this.mapShow = false;
                    this.dialogStatus = 'update';
                });
        },
        handleDelete(row) {
            this.$confirm('此操作将永久删除, 是否继续?', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            })
                .then(() => {
                    delObj(row.oilid)
                        .then(() => {
                            this.$notify({
                                title: '成功',
                                message: '删除成功',
                                type: 'success',
                                duration: 2000
                            });
                            const index = this.list.indexOf(row);
                            this.list.splice(index, 1);
                        });
                });
        },
        create(formName) {
            const set = this.$refs;
            set[formName].validate(valid => {
                if (valid) {
                    addObj(this.form)
                        .then(() => {
                            this.dialogFormVisible = false;
                            this.getList();
                            this.$notify({
                                title: '成功',
                                message: '创建成功',
                                type: 'success',
                                duration: 2000
                            });
                        })
                } else {
                    return false;
                }
            });
        },
        cancel(formName) {
            this.dialogFormVisible = false;
            const set = this.$refs;
            set[formName].resetFields();
        },
        update(formName) {
            const set = this.$refs;
            set[formName].validate(valid => {
                if (valid) {
                    this.dialogFormVisible = false;
                    this.form.password = undefined;
                    putObj(this.form.id, this.form).then(() => {
                        this.dialogFormVisible = false;
                        this.getList();
                        this.$notify({
                            title: '成功',
                            message: '创建成功',
                            type: 'success',
                            duration: 2000
                        });
                    });
                } else {
                    return false;
                }
            });
        },
        resetTemp() {
            this.form = {
                oilid: null,
                materialName: null,
                explainText: null,
                materialType: null,
                formType: null,
                sort: null,
            };
        },
        resetForm() {
            this.listQuery = {
                page: 1,
                limit: 20,
                oilEdequipmentCode: null,
                truckNo: null,
            }
        }
    }
}
</script>

